import { infos } from "../../../model/infos";

export interface IState {
    informations: Array<infos>;
    // selectedContactReminders: Array<reminder>;
    isLoadingInfos: boolean;
    // openDialog: boolean;
}


export const DefaultState = (): IState => ({
    informations: [],
    // selectedContactReminders: [],
    isLoadingInfos: false,
    // openDialog: false,
})
